function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  x: "-37.5%",
  y: "-37.5%",
  width: "175.0%",
  height: "175.0%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "2.3.4-\\u2013-System-Admin-\\u2013-Content-Repo-\\u2013-Themes-\\u2013-Default",
  transform: "translate(-117.000000, -376.000000)"
}, React.createElement("g", {
  id: "Group-47",
  transform: "translate(72.000000, 336.000000)"
}, React.createElement("g", {
  id: "Star-icon",
  filter: "url(#filter-1)",
  transform: "translate(51.000000, 46.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 16
}), React.createElement("circle", {
  id: "Oval",
  fillOpacity: 0.3,
  fill: "#215EFF",
  cx: 16,
  cy: 16,
  r: 13
}), React.createElement("path", {
  d: "M17.1011986,8.78561121 L18.2023973,12.1697826 C18.3635483,12.6532357 18.7932843,12.9755377 19.3035959,12.9755377 L22.8489183,12.9755377 C23.9501169,12.9755377 24.43357,14.3990384 23.5203809,15.0436424 L20.646521,17.1386057 C20.2436435,17.4340492 20.0824925,17.9443608 20.216785,18.4278138 L21.3179836,21.8119852 C21.6671441,22.8594668 20.4585115,23.7457974 19.5453224,23.1011933 L16.6714626,21.0062301 C16.268585,20.7107866 15.731415,20.7107866 15.3285374,21.0062301 L12.4546776,23.1011933 C11.5414885,23.7457974 10.3328559,22.8863253 10.6820164,21.8119852 L11.783215,18.4278138 C11.944366,17.9443608 11.7563565,17.4340492 11.353479,17.1386057 L8.47961914,15.0436424 C7.56643004,14.3990384 8.04988309,12.9755377 9.15108172,12.9755377 L12.6964041,12.9755377 C13.2067157,12.9755377 13.6364517,12.6532357 13.7976027,12.1697826 L14.8988014,8.78561121 C15.2479619,7.7381296 16.7520381,7.7381296 17.1011986,8.78561121 Z",
  id: "Path",
  fill: "#215EFF",
  fillRule: "nonzero"
})))));

const SvgStarIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgStarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star-icon.df7edcc2.svg";
export { ForwardRef as ReactComponent };